import { Modal } from "@mui/material";
import { useFormik } from "formik";
import { useState } from "react";
import { FaLock, FaLockOpen } from "react-icons/fa";
import { RxCross2 } from "react-icons/rx";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import MyButton from "../../components/MyButton";
import MyInput from "../../components/MyInput";
import useApi from "../../Hooks/useApi";
import { deleteAccountSchema } from "../../schema";
import classes from "./DeleteAccountModal.module.css";
import { logout } from "../../store/authSlice";
import { clearAllRanges } from "../../store/ammenitiesRangeSlice";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
const initialValues = {
    password: ""
};
const DeleteAccountModal = ({ show, setShow, children, handler, data = null }) => {
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const api = useApi();
    const { deviceToken } = useSelector(state => state?.FCMReducer);
    console.log("deviceToken check", deviceToken)
    const formik = useFormik({
        initialValues,
        validationSchema: deleteAccountSchema,
        onSubmit: async (values, { resetForm }) => {
            // setLoading(true);
            try {
                const params = {
                    password: values?.password,
                    deviceToken,
                };
                await deleteAccountHandler()
                // navigate(-1);
                resetForm();
            } catch (error) {

                toast.error("Something Went Wrong");
            }
            // setLoading(false);
        },
    });


    const {
        touched,
        errors,
        values,
        handleSubmit,
        setFieldValue,
        setFieldTouched,
        setValues,
        isVaild,
        dirty
    } = formik;

    const handleChangeWithTouch = (field) => (value) => {
        setFieldValue(field, value);
        setFieldTouched(field, true, false);
    };

    const logoutActions = () => {
        dispatch(logout());
        dispatch(clearAllRanges());
        setShow(false);
    };


    const handleLogout = async () => {
        const response = await api?.logout();
        if (response?.data?.headers?.code === 200) {
            logoutActions()
        }
        else {
            toast.error(response?.data?.headers?.msg);
        }

    }
    const deleteAccountHandler = async () => {
        setLoading(true);
        try {
            const params = {
                password: values?.password,
                deviceToken
            };
            const response = await api?.deleteAccountApi(params);
            if (response?.data?.headers?.code === 200) {

                handleLogout()
            } else {
                toast.error(response?.data?.headers?.msg);
            }
        } catch (error) {

            toast.error("Something Went Wrong");
            // Re-throw to let onSubmit handle it
        }
        setLoading(false);
    };

    return (
        <>
            <style>{`
      {/* .transform-component-module_wrapper__SPB86 {
       width:100%;
      } */}
    `}</style>
            <Modal
                open={show}
                onClose={() => {
                    setShow(false)
                    // navigate(-1);
                }}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <form className={classes.container} onSubmit={handleSubmit}>
                    <div className={classes.header}>

                        <h3 className={classes.title}>
                            Delete Account
                        </h3>
                        <span className={classes.icon} onClick={() => {
                            setShow(false)
                            navigate(-1);
                        }}>
                            <RxCross2 color="#fff" />

                        </span>
                    </div>

                    <p className={classes.description}>
                        Deleting your account will permanently erase all Community data, and User Information. <strong className={classes.bold}>This action cannot be undone.</strong> Are you sure you want to proceed?
                    </p>
                    <div className={classes["detailswrapper"]}>
                        <MyInput
                            name="password"
                            label="Password"
                            value={values?.password}
                            setter={(e) =>
                                handleChangeWithTouch("password")(e.target.value)
                            }
                            error={touched?.password && errors?.password}
                            type={showPassword ? "text" : "password"}
                            leftIcon={
                                showPassword ? (
                                    <FaLockOpen
                                        color="var(--main-color-dark)"
                                        style={{ cursor: "pointer" }}
                                    />
                                ) : (
                                    <FaLock
                                        color="var(--main-color-dark)"
                                        style={{ cursor: "pointer" }}
                                    />
                                )
                            }
                            leftIconHandler={() => setShowPassword(!showPassword)}
                        />
                    </div>

                    <div className={classes.ctaWrapper}>
                        <MyButton
                            className={classes.cancelButton}
                            handler={() => {
                                setShow(false)
                            }}
                            btnText={"Cancel"}
                        />
                        <MyButton
                            handler={() => {
                                if (values?.password) {

                                    // handler({
                                    //     password: values?.password,
                                    // })

                                }
                            }}
                            disabled={loading || !values?.password}
                            btnText={"Delete"}
                            type="submit"

                        />
                    </div>
                </form>

            </Modal>
        </>
    );
};

export default DeleteAccountModal;
